(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["afb-homepage-v2"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = window.matchMedia('(max-width: 900px)').matches;
  var home = document.querySelector('.afb-home');
  var stack = document.getElementById('stack');
  function showHero(){
    document.body.classList.add('loaded');
    if(home){
      home.classList.add('hero-visible');
      if(mobile){ home.classList.add('hero-mobile-visible'); }
    }
    if(stack){ stack.classList.add('settled'); }
  }
  if(home && !reduced){ home.classList.add('hero-motion-ready'); }
  if(mobile || reduced){
    requestAnimationFrame(showHero);
  }else{
    requestAnimationFrame(function(){ setTimeout(showHero, 140); });
  }
  window.addEventListener('load', showHero, {once:true});
  setTimeout(showHero, 1200);
  if(stack && !reduced){ setTimeout(function(){ stack.classList.add('floating'); }, 1900); }
  var bar = document.getElementById('progress');
  var reveals = Array.prototype.slice.call(document.querySelectorAll('.reveal'));
  function onScroll(){
    var h = document.documentElement;
    var p = h.scrollTop / (h.scrollHeight - h.clientHeight) * 100;
    if(bar) bar.style.width = p + '%';
    for(var i=reveals.length-1;i>=0;i--){
      var r = reveals[i].getBoundingClientRect();
      if(r.top < window.innerHeight){ reveals[i].classList.add('gone'); reveals.splice(i,1); }
    }
  }
  document.addEventListener('scroll', onScroll, {passive:true}); onScroll();
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting) return;
      e.target.classList.add('gone');
      e.target.querySelectorAll('[data-count]').forEach(function(el){
        if(el.dataset.done) return; el.dataset.done = 1;
        var end = parseInt(el.dataset.count,10), t0 = null, dur = 1100;
        if(reduced){ el.textContent = end; return; }
        el.textContent = '0';
        function tick(ts){ if(!t0) t0 = ts;
          var k = Math.min(1,(ts-t0)/dur); k = 1-Math.pow(1-k,3);
          el.textContent = Math.round(end*k);
          if(k<1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
      io.unobserve(e.target);
    });
  }, {threshold:.18});
  document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
})();

(function(){
  var section=document.querySelector('#method');
  if(!section) return;
  var steps=[].slice.call(section.querySelectorAll('.step[data-stage]'));
  var rows=[].slice.call(section.querySelectorAll('.workflow-row[data-stage]'));
  if(!steps.length || steps.length!==rows.length) return;
  if(window.matchMedia && window.matchMedia('(max-width: 860px)').matches) return;
  section.classList.add('method-flow-ready');
  var active=null;
  function setActive(stage){
    if(active===stage) return;
    active=stage;
    rows.forEach(function(row){ row.classList.toggle('is-active', row.getAttribute('data-stage')===stage); });
  }
  function update(){
    var line=window.innerHeight*0.40;
    var best=steps[0], bestDist=Infinity;
    steps.forEach(function(step){
      var r=step.getBoundingClientRect();
      var center=r.top + Math.min(r.height, 180)/2;
      var dist=Math.abs(center-line);
      if(dist<bestDist){ bestDist=dist; best=step; }
    });
    setActive(best.getAttribute('data-stage'));
  }
  var ticking=false;
  function onScroll(){
    if(ticking) return;
    ticking=true;
    requestAnimationFrame(function(){ update(); ticking=false; });
  }
  update();
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll);
})();

(function(){
  var mq = window.matchMedia('(max-width: 860px)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var section = document.querySelector('#method');
  if(!section) return;
  var timeline = section.querySelector('.timeline');
  var draw = section.querySelector('.timeline .draw');
  var steps = [].slice.call(section.querySelectorAll('.step[data-stage]'));
  if(!timeline || !draw || !steps.length) return;

  var enabled = false, ticking = false;

  function enable(){
    if(enabled) return; enabled = true;
    section.classList.add('method-mobile-ready');
    if(reduced){
      // final state, no scroll wiring
      steps.forEach(function(s){ s.classList.add('is-complete-step'); });
      return;
    }
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', onScroll, {passive:true});
    onScroll();
  }
  function disable(){
    if(!enabled) return; enabled = false;
    section.classList.remove('method-mobile-ready');
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onScroll);
    steps.forEach(function(s){ s.classList.remove('is-active-step','is-complete-step'); });
    draw.style.height = '';
  }

  function onScroll(){
    if(ticking) return; ticking = true;
    requestAnimationFrame(function(){
      ticking = false;
      var vh = window.innerHeight;
      var mid = vh * 0.40;              // activation line = 40% of viewport, matching desktop #method-scroll-link
      var tRect = timeline.getBoundingClientRect();

      // progressive draw: how far the activation line has travelled through the timeline
      var total = tRect.height - 16;
      var travelled = Math.min(Math.max(mid - (tRect.top + 8), 0), total);
      draw.style.height = travelled + 'px';

      // active/complete steps relative to the activation line (nearest-wins, matching desktop)
      var activeIndex = -1;
      for(var i=0;i<steps.length;i++){
        var r = steps[i].getBoundingClientRect();
        if(r.top <= mid){ activeIndex = i; }
      }
      steps.forEach(function(s, i){
        s.classList.toggle('is-active-step', i === activeIndex);
        s.classList.toggle('is-complete-step', i < activeIndex);
      });
    });
  }

  function apply(){ if(mq.matches){ enable(); } else { disable(); } }
  // modern + legacy listener
  if(mq.addEventListener){ mq.addEventListener('change', apply); }
  else if(mq.addListener){ mq.addListener(apply); }
  apply();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["afb-homepage"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = window.matchMedia('(max-width: 900px)').matches;
  var home = document.querySelector('.afb-home');
  var stack = document.getElementById('stack');
  function showHero(){
    document.body.classList.add('loaded');
    if(home){
      home.classList.add('hero-visible');
      if(mobile){ home.classList.add('hero-mobile-visible'); }
    }
    if(stack){ stack.classList.add('settled'); }
  }
  if(home && !reduced){ home.classList.add('hero-motion-ready'); }
  if(mobile || reduced){
    requestAnimationFrame(showHero);
  }else{
    requestAnimationFrame(function(){ setTimeout(showHero, 140); });
  }
  window.addEventListener('load', showHero, {once:true});
  setTimeout(showHero, 1200);
  if(stack && !reduced){ setTimeout(function(){ stack.classList.add('floating'); }, 1900); }
  var bar = document.getElementById('progress');
  var reveals = Array.prototype.slice.call(document.querySelectorAll('.reveal'));
  function onScroll(){
    var h = document.documentElement;
    var p = h.scrollTop / (h.scrollHeight - h.clientHeight) * 100;
    if(bar) bar.style.width = p + '%';
    for(var i=reveals.length-1;i>=0;i--){
      var r = reveals[i].getBoundingClientRect();
      if(r.top < window.innerHeight){ reveals[i].classList.add('gone'); reveals.splice(i,1); }
    }
  }
  document.addEventListener('scroll', onScroll, {passive:true}); onScroll();
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting) return;
      e.target.classList.add('gone');
      e.target.querySelectorAll('[data-count]').forEach(function(el){
        if(el.dataset.done) return; el.dataset.done = 1;
        var end = parseInt(el.dataset.count,10), t0 = null, dur = 1100;
        if(reduced){ el.textContent = end; return; }
        el.textContent = '0';
        function tick(ts){ if(!t0) t0 = ts;
          var k = Math.min(1,(ts-t0)/dur); k = 1-Math.pow(1-k,3);
          el.textContent = Math.round(end*k);
          if(k<1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
      io.unobserve(e.target);
    });
  }, {threshold:.18});
  document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
})();

(function(){
  var section=document.querySelector('#method');
  if(!section) return;
  var steps=[].slice.call(section.querySelectorAll('.step[data-stage]'));
  var rows=[].slice.call(section.querySelectorAll('.workflow-row[data-stage]'));
  if(!steps.length || steps.length!==rows.length) return;
  if(window.matchMedia && window.matchMedia('(max-width: 860px)').matches) return;
  section.classList.add('method-flow-ready');
  var active=null;
  function setActive(stage){
    if(active===stage) return;
    active=stage;
    rows.forEach(function(row){ row.classList.toggle('is-active', row.getAttribute('data-stage')===stage); });
  }
  function update(){
    var line=window.innerHeight*0.40;
    var best=steps[0], bestDist=Infinity;
    steps.forEach(function(step){
      var r=step.getBoundingClientRect();
      var center=r.top + Math.min(r.height, 180)/2;
      var dist=Math.abs(center-line);
      if(dist<bestDist){ bestDist=dist; best=step; }
    });
    setActive(best.getAttribute('data-stage'));
  }
  var ticking=false;
  function onScroll(){
    if(ticking) return;
    ticking=true;
    requestAnimationFrame(function(){ update(); ticking=false; });
  }
  update();
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll);
})();

(function(){
  var mq = window.matchMedia('(max-width: 860px)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var section = document.querySelector('#method');
  if(!section) return;
  var timeline = section.querySelector('.timeline');
  var draw = section.querySelector('.timeline .draw');
  var steps = [].slice.call(section.querySelectorAll('.step[data-stage]'));
  if(!timeline || !draw || !steps.length) return;

  var enabled = false, ticking = false;

  function enable(){
    if(enabled) return; enabled = true;
    section.classList.add('method-mobile-ready');
    if(reduced){
      // final state, no scroll wiring
      steps.forEach(function(s){ s.classList.add('is-complete-step'); });
      return;
    }
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', onScroll, {passive:true});
    onScroll();
  }
  function disable(){
    if(!enabled) return; enabled = false;
    section.classList.remove('method-mobile-ready');
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onScroll);
    steps.forEach(function(s){ s.classList.remove('is-active-step','is-complete-step'); });
    draw.style.height = '';
  }

  function onScroll(){
    if(ticking) return; ticking = true;
    requestAnimationFrame(function(){
      ticking = false;
      var vh = window.innerHeight;
      var mid = vh * 0.40;              // activation line = 40% of viewport, matching desktop #method-scroll-link
      var tRect = timeline.getBoundingClientRect();

      // progressive draw: how far the activation line has travelled through the timeline
      var total = tRect.height - 16;
      var travelled = Math.min(Math.max(mid - (tRect.top + 8), 0), total);
      draw.style.height = travelled + 'px';

      // active/complete steps relative to the activation line (nearest-wins, matching desktop)
      var activeIndex = -1;
      for(var i=0;i<steps.length;i++){
        var r = steps[i].getBoundingClientRect();
        if(r.top <= mid){ activeIndex = i; }
      }
      steps.forEach(function(s, i){
        s.classList.toggle('is-active-step', i === activeIndex);
        s.classList.toggle('is-complete-step', i < activeIndex);
      });
    });
  }

  function apply(){ if(mq.matches){ enable(); } else { disable(); } }
  // modern + legacy listener
  if(mq.addEventListener){ mq.addEventListener('change', apply); }
  else if(mq.addListener){ mq.addListener(apply); }
  apply();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
